import api from '../../services/service_expend'
import Swal from 'sweetalert2'
import Multiselect from 'vue-multiselect'
import CateView from '../../components/cate_view'
import SubcateView from '../../components/subcate_view'
import Pagination from 'vue-pagination-2'
import vuejsDatepicker from 'vuejs-datepicker'
import { th } from 'vuejs-datepicker/dist/locale'

export default {
  components: {
    Multiselect,
    CateView,
    SubcateView,
    Pagination,
    vuejsDatepicker
  },
  data () {
    return {
      now_date: this.dateFormatDMY2(new Date()),
      end_date: this.dateFormatDMY2(new Date()),
      search: '',
      cate_exp_list: [],
      cate_exp_id: '',
      exp_list: {
        pagination: []
      },
      header: {
        headers: {
          'access-token': this.$store.state.token
        }
      },
      activePage: 1,
      allItem: 0,
      ItemPerpage: 10,
      th: th
    }
  },
  methods: {
    callback: function (page) {
      this.activePage = page
      this.getExpSub()
    },
    getExpSub () {
      this.$store.state.isLoading = true
      var body = {
        search: this.search,
        date: this.now_date,
        date_end: this.end_date,
        category_id: this.cate_exp_id,
        active_page: this.activePage,
        per_page: this.ItemPerpage
      }
      this.exp_list = []
      api.searchExpenSub(
        body,
        this.header,
        result => {
          if (result.response === true) {
            this.exp_list = result.data
            this.allItem = result.data.count
          } else {
            Swal.fire('ดึงข้อมูลหมวดหมู่', result.message, 'warning')
          }
          this.$store.state.isLoading = false
        },
        error => {
          alert(JSON.stringify(error))
          this.$store.state.isLoading = false
        }
      )
    },
    getCateExp() {
      this.$store.state.isLoading = true
      var body = {
        search: '',
        active_page: 1,
        per_page: 10000000000000
      }
      api.getCate(
        body,
        this.header,
        result => {
          if (result.response === true) {
            this.cate_exp_list = []
            result.data.forEach(val => {
              this.cate_exp_list.push({
                'cate_exp_id': val['cate_exp_id'],
                'cate_exp_name': val['cate_exp_name']
              })
            })
            if (this.cate_exp === 0) {
              this.cate_exp = this.cate_exp_list[0]
            }
            this.getExpSub()
          } else {
            Swal.fire('ดึงข้อมูลหมวดหมู่', result.message, 'warning')
          }
          this.$store.state.isLoading = false
        },
        error => {
          alert(JSON.stringify(error))
          this.$store.state.isLoading = false
        }
      )
    }
  },
  mounted () {
    this.getCateExp()
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/manage_expensub.js